import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CheckboxModule } from '@shared/checkbox';
import { ModalNoteDeclinedComponent } from '@shared/modal/note-declined/modal-note-declined.component';
import { ModalNoteRejectedComponent } from '@shared/modal/note-rejected/modal-note-rejected.component';
import { MojoEditorModule } from 'mojo-editor';

import { ModalComponent } from './modal.component';
import { ModalEffects } from './modal.effects';
import { modalReducer } from './modal.reducer';
import { ModalNoteComponent } from './note/modal-note.component';

@NgModule({
  imports: [
    CheckboxModule,
    CommonModule,
    MatDialogModule,
    StoreModule.forFeature('modal', modalReducer),
    EffectsModule.forFeature([ModalEffects]),
    ReactiveFormsModule,
    MojoEditorModule.forRoot(EDITOR_SERVICE),
    MatButtonModule,
  ],
  declarations: [
    ModalComponent,
    ModalNoteComponent,
    ModalNoteRejectedComponent,
    ModalNoteDeclinedComponent,
  ],
  exports: [
    ModalComponent,
    ModalNoteComponent,
    ModalNoteRejectedComponent,
    ModalNoteDeclinedComponent,
  ],
  providers: [ModalEffects],
})
export class ModalModule {}
